// TL;DR-block för AEO. 40–60 ord, direkt-svar på sidans target-keyword.
// `data-speakable` markerar att Google/AI får läsa upp/citera blocket.
// Använd överst på alla pillar-, format-, pris- och kunskaps-sidor.

import { cn } from "@/lib/utils";

interface TldrProps {
  children: React.ReactNode;
  label?: string;
  className?: string;
}

export function Tldr({ children, label = "TL;DR", className }: TldrProps) {
  return (
    <aside
      data-speakable
      className={cn(
        "tldr rounded-2xl border border-white/10 bg-white/[0.03] p-5 md:p-6",
        "text-base leading-relaxed text-foreground/90",
        className,
      )}
      aria-label={label}
    >
      <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-mint">
        {label}
      </div>
      <div className="[&_p]:m-0">{children}</div>
    </aside>
  );
}
